import CheckIcon from '@mui/icons-material/Check';
import { ToggleButton, ToggleButtonProps } from '@mui/material';
import clsx from 'clsx';
import { useEffect, useRef, useState } from 'react';

const CheckToggleButton = (props: ToggleButtonProps) => {
    const ref = useRef<HTMLButtonElement>(null);
    const [disabled, setDisabled] = useState(false);
    const [selected, setSelected] = useState(false);

    const checkStatuses = () => {
        const hasDisabled = ref.current?.classList.contains('Mui-disabled');
        const hasSelected = ref.current?.classList.contains('Mui-selected');
        setDisabled(!!hasDisabled);
        setSelected(!!hasSelected);
    };

    useEffect(() => {
        const targetNode = ref.current;

        if (!targetNode) return;

        const observer = new MutationObserver((mutations) => {
            for (const mutation of mutations) {
                if (mutation.attributeName === 'class') {
                    checkStatuses();
                }
            }
        });

        observer.observe(targetNode, {
            attributes: true,
            attributeFilter: ['class'],
        });

        checkStatuses();

        // Cleanup
        return () => observer.disconnect();
    }, []);

    return (
        <ToggleButton
            ref={ref}
            disableRipple
            {...props}
            className={clsx(
                props.className,
                'border-0 bg-transparent text-spanish-gray hover:text-black px-0 border-b-[1px] py-[5px]',
                {
                    'border-primary-600 !text-black': selected && !disabled,
                }
            )}
        >
            <div className="w-full flex justify-between">
                {props.children}
                {selected ? <CheckIcon className="ml-auto" /> : null}
            </div>
        </ToggleButton>
    );
};

export { CheckToggleButton };
